import React, { Component } from "react";
import { connect } from "react-redux";
import {
  actionOrderDetails,
  actionProcessingJobs,
  getStoreAction,
  actionIntransitJob,
} from "../../../actions/index";
import { bindActionCreators } from "redux";
import { NavLink } from "react-router-dom";
import api from "../../../utility/api/api.js";
//import CancelOrder from './CancelOrder';
import { Row, Col } from "reactstrap";
import PhoneIcon from "../../../images/call_icon.png";
import Reschedule from "./Reschedule";
import Notifyreason from "./notifyreason";
import { notify } from "react-notify-toast";
import navigateImage from "../../../images/navi_icon20.png";
import callImage from "../../../images/call_icon20.png";
import HoldReasons from "../ViewTripList/HoldReasons";
import ReturnReason from "../DeliverOrder/ReturnReason";
import loader from "../../../images/loader.gif";

let orderList = [];
class OrderInTransit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      latlongCurrent: "",
      apilatlongCurrent: "",
      notifyevent: true,
      notifyDisable: true,
      isLoading: false,
    };
    //this.getLocation();
    this.notifyClick = this.notifyClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentWillMount() {
    if (this.props.orderData) {
      this.setState({
        apilatlongCurrent:
          this.props.orderData.latitude + "," + this.props.orderData.longitude,
      });
    }
  }
  componentDidMount() {
    this.timerId = setInterval(() => this.getLocation(), 1000);
    const checkStoreData = api.getListOfStore(this);
  }
  getOrder(job_order_id) {
    this.props.actionOrderDetails(null);
    api.callOrderShippingJobs(this, job_order_id);
  }
  notifyClick(e) {
    if (!this.state.latlongCurrent) {
      notify.show("Please Enable GPS", "error", 2000);
      e.preventDefault();
    }
  }
  getLocation(e) {
    if (navigator.geolocation) {
      navigator.geolocation.watchPosition(
        (position) => {
          this.setState({
            latlongCurrent:
              position.coords.latitude + "," + position.coords.longitude,
          });
        },
        (error) => {
          this.setState({ message: error.message, latlongCurrent: "" });
        }
      );
    } else {
      //    x.innerHTML = "Geolocation is not supported by this browser.";
    }
  }
  notifyClick() {
    let _this = this;
    this.setState({
      notifyevent: false,
    });
    setTimeout(() => {
      _this.setState({
        notifyDisable: false,
      });
    }, 180000);
  }

  handleChange(e) {
    if (orderList.length == 0) {
      orderList.push(e.target.value);
    } else {
      let index = orderList.indexOf(e.target.value);
      if (index >= 0) {
        orderList.splice(index, 1);
      } else {
        orderList.push(e.target.value);
      }
    }
    localStorage.setItem("ordersArr", JSON.stringify(orderList));
  }
  changeToInTransit = async (orderId) => {
    console.log(this.props);
    // alert("ggg");
    this.setState({ isLoading: true });
    const res = await api.changeOrderToInTransit(orderId);
    console.log("changeToInTransit", res);
    if (res && res[0] && res[0].status != "failure") {
      // await api.callShippingJobs(this, this.props.trip_id);
      await api.callAssignedJobs(this, "in-transit");
    }
    this.setState({ isLoading: false });
  };

  changeToReject = async (orderId) => {
    console.log(this.props);
    // alert("ggg");
    this.setState({ isLoading: true });
    const res = await api.changeOrderToReject(orderId, this.props.trip_id);
    console.log("changeToInTransit", res);
    if (res && res[0] && res[0].status != "failure") {
      await api.callShippingJobs(this, this.props.trip_id);
    }
    this.setState({ isLoading: false });
  };

  render() {
    const orderData = this.props.orderData;
    const isFromAcceptModal = this.props.isFromAcceptModal;
    // console.log("storeData", this.props.orderData);
    // console.log(
    //   "apilatlongCurrent",
    //   this.state.apilatlongCurrent,
    //   this.state.latlongCurrent
    // );
    const addressString = [
      "flat_villa_no",
      "building",
      "street",
      "city",
      "postcode",
    ]
      .map((key) => {
        const lables = {
          street: "Street",
          city: "City",
          flat_villa_no: "Flat",
          building: "Building",
          postcode: "Pincode",
        };
        return orderData[key] && lables[key] + ":" + orderData[key];
      })
      .filter((n) => n)
      .join(", ");

    const matchedStore =
      this.props.storeData &&
      orderData &&
      orderData.source_code &&
      this.props.storeData.items &&
      this.props.storeData.items.find(
        (item) => item.source_code == orderData.source_code
      );
    const storeName =
      matchedStore && matchedStore.name ? matchedStore.name : "";
    return (
      <div className="order_detail_container">
        <div className="inTransitOrdercontainer">
          {/* Order header*/}
          <div>
            <div className="orderDataIntransit">
              {/* <Col xs="2" className="order_index order_data_details">
                <span>{this.props.index}</span>
              </Col> */}
              <div className="orderDataIntransitHeaderItem">
                ORDER <br /> <span>{orderData.increment_id}</span>
              </div>
              <div className="orderIntransitVerticalDivider" />
              <div className="orderDataIntransitHeaderItem">
                STATUS
                <br /> <span>{orderData.order_status}</span>
              </div>
              <div className="orderIntransitVerticalDivider" />
              <div className="orderDataIntransitHeaderItem">
                AMOUNT <br />{" "}
                <span>{parseFloat(orderData.order_amount).toFixed(3)}</span>
              </div>
              <div className="orderIntransitVerticalDivider" />
              <div className="orderDataIntransitHeaderItem">
                PAYMENT <br /> <span>{orderData.payment_method}</span>
              </div>
            </div>
          </div>
          <table className="order_data_table w-100 d-inline-block orderInTransitTabel">
            <tbody className="w-100 d-inline-block">
              {/* {orderData.delivery_status != "delivered" &&
                orderData.delivery_status != "rescheduled" && (
                  <tr>
                    <td className="order_data_label pb-2">
                      <input
                        onChange={(e) => this.handleChange(e)}
                        value={orderData.job_order_id}
                        className="order-detail-checkbox"
                        type="checkbox"
                      />
                    </td>
                  </tr>
                )} */}
              <tr>
                <td className="order_data_label">Quantity:</td>
                <td>
                  {parseInt(orderData.order_article_count)}{" "}
                  {parseInt(orderData.order_article_count) > 1
                    ? "Items"
                    : "Item"}
                  {" in "}
                  {parseInt(orderData.box)}{" "}
                  {parseInt(orderData.box) > 1 ? "Boxs" : "Box"}
                  {/* in{" "}
                  {orderData.total_tray} bags */}
                </td>
              </tr>
              <tr>
                <td className="order_data_label ">Delivery At:</td>
                <td className="text-uppercase">{orderData.slot_time}</td>
              </tr>
              <tr>
                <td className="order_data_label ">Store:</td>
                <td className="text-uppercase">
                  {orderData.source_code} - {storeName}
                </td>
              </tr>
              {/* {orderData.customer_note && ( */}
              <tr>
                <td className="order_data_label ">Delivery Note:</td>
                <td className="text-uppercase">{orderData.customer_note}</td>
              </tr>
              {/* )} */}
              <tr>
                <td className="order_data_label">Customer:</td>
                <td className="">{orderData.customer_name}</td>
              </tr>
              <tr>
                <td className="order_data_label">Loyalty Tier:</td>
                <td className="">{orderData.loyalty_tier}</td>
              </tr>
              <tr>
                <td className="order_data_label">Customer Tag:</td>
                <td className="">{orderData.customer_tag}</td>
              </tr>
              <tr>
                <td className="order_data_label ">Address:</td>
                <td className="text-capitalize">
                  {/* <div> */}
                  {addressString}
                  <br />
                  Location:{orderData.location}
                  {/* {orderData.address.city}, {orderData.address.region},
                  <p>{orderData.address.postcode}</p> */}
                  {/* </div> */}
                </td>
                {orderData.longitude && !isFromAcceptModal && (
                  <td className="navigateContainer">
                    <a
                      className="navigate"
                      // href="geo:124.028582,-29.201930"
                      target="_blank"
                      href={`https://www.google.com/maps/dir/?api=1&origin=${this.state.latlongCurrent}&destination=${this.state.apilatlongCurrent}&travelmode=driving`}
                      // onClick={(e) => this.notify(e)}
                    >
                      Navigate
                      <img src={navigateImage} height="20px" />
                    </a>
                  </td>
                )}
                {/* <td className="">
                  <div>
                    <div className="navigationArrow"></div>
                  </div>
                </td> */}
              </tr>
              <tr>
                <td className="order_data_label ">Contact:</td>
                {/* <td className="">
                  <a href={`tel:${orderData.telephone}`}>
                    <img src={PhoneIcon} alt="Call" />
                  </a>
                </td> */}
                <td className="text-capitalize">{orderData.telephone}</td>
                {orderData.telephone && !isFromAcceptModal && (
                  <td className="navigateContainer">
                    <a
                      className="phone"
                      href={`tel:${orderData.telephone}`}
                      // onClick={(e) => this.notify(e)}
                    >
                      Call
                      <img src={callImage} height="20px" />
                    </a>
                  </td>
                )}
              </tr>
              {!isFromAcceptModal && orderData && (
                <div>
                  {orderData.order_status == "intransit" &&
                  orderData.status == "In Transit" ? (
                    <tr>
                      <td className="order_details_button view_deliver_btn ">
                        <ReturnReason
                          component={this}
                          orderData={this.props.orderData}
                          label="CANCEL"
                        />
                      </td>

                      <td className="order_details_button view_deliver_btn ">
                        <HoldReasons
                          component={this}
                          trip_id={orderData.rider_job_id}
                          order_id={orderData.job_order_id}
                          label="HOLD"
                        />
                      </td>
                      <td className="order_details_button view_deliver_btn ">
                        <NavLink
                          className="orderAnchor"
                          onClick={(e) => this.getOrder(orderData.job_order_id)}
                          to="/deliveryorder"
                        >
                          DELIVER
                        </NavLink>
                      </td>
                      {/* <td className="order_details_button view_deliver_btn pt-3">
                    {orderData.longitude ? (
                      <a
                        href={`https://www.google.com/maps/dir/?api=1&origin=${this.state.latlongCurrent}&destination=${this.state.apilatlongCurrent}&travelmode=driving`}
                        onClick={(e) => this.notify(e)}
                      >
                        Navigate
                      </a>
                    ) : (
                      ""
                    )}
                  </td> */}

                      {orderData && !this.state.notifyevent && (
                        <td className="order_details_button view_deliver_btn pt-3">
                          <button
                            className="disabledButton"
                            disabled={this.state.notifyDisable}
                          >
                            <Reschedule
                              notifyDisable={this.state.notifyDisable}
                              trip_id={this.props.trip_id}
                              order_id={this.props.orderData.job_order_id}
                              label="Reshedule"
                            />
                          </button>
                        </td>
                      )}
                      {/* {this.state.notifyevent && (
                    <td className="order_details_button view_deliver_btn pt-3">
                      <Notifyreason
                        notifyChild={this.notifyClick.bind(this)}
                        trip_id={this.props.trip_id}
                        order_id={this.props.orderData.job_order_id}
                        label="Notify"
                      />
                    </td>
                  )} */}
                    </tr>
                  ) : orderData.order_status == "ready_to_dispatch" ? (
                    <tr>
                      {this.state.isLoading ? (
                        <td className="inTransitloaderContainer">
                          <img src={loader} height="40px" />
                        </td>
                      ) : (
                        <td
                          colSpan="2"
                          className="order-status pt-1 pb-1 text-center text-uppercase inTransitRejectButton"
                          onClick={() =>
                            this.changeToReject(orderData.order_id)
                          }
                        >
                          Reject
                        </td>
                      )}

                      {!this.state.isLoading && (
                        <td
                          colSpan="2"
                          className="order-status pt-1 pb-1 text-center text-uppercase pickupButton"
                          onClick={() =>
                            this.changeToInTransit(orderData.order_id)
                          }
                        >
                          Pick Up
                        </td>
                      )}
                    </tr>
                  ) : orderData.status == "hold" ? (
                    <tr>
                      {this.state.isLoading ? (
                        <td className="inTransitloaderContainer">
                          <img src={loader} height="40px" />
                        </td>
                      ) : (
                        <td
                          colSpan="2"
                          className="order-status pt-1 pb-1 text-center text-uppercase pickupButton"
                          onClick={() =>
                            this.changeToInTransit(orderData.order_id)
                          }
                        >
                          Un Hold
                        </td>
                      )}
                    </tr>
                  ) : (
                    <tr className="order-status-container">
                      <td
                        colSpan="2"
                        className="order-status pt-1 pb-1 text-center text-uppercase"
                      >
                        {orderData.status}
                      </td>
                    </tr>
                  )}
                </div>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    // login: state.login,
    storeData: state.getstoredata,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionOrderDetails: actionOrderDetails,
      actionProcessingJobs: actionProcessingJobs,
      getStoreAction: getStoreAction,
      actionIntransitJob: actionIntransitJob,
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderInTransit);



// WEBPACK FOOTER //
// ./src/components/Intransit/ViewTripList/OrderInTransit.js